import React from 'react';
import { motion } from 'framer-motion';
import { Users, Wallet, CreditCard, CheckCircle2, ClockIcon } from 'lucide-react';
const steps = [{
  icon: <Users className="w-6 h-6 text-kitty-dark" data-id="element-140" />,
  title: 'Everyone chips in',
  description: 'Create a kitty and invite your group. Everyone adds money upfront via Apple Pay, Google Pay, or card.'
}, {
  icon: <Wallet className="w-6 h-6 text-kitty-dark" data-id="element-141" />,
  title: 'Spend and log instantly',
  description: 'Pay as you normally would. Log expenses in seconds — done.'
}, {
  icon: <CreditCard className="w-6 h-6 text-kitty-dark" data-id="element-142" />,
  title: 'See everything in real time',
  description: 'Every payment tracked automatically. Everyone sees where the money goes.'
}, {
  icon: <CheckCircle2 className="w-6 h-6 text-kitty-dark" data-id="element-143" />,
  title: 'Close the kitty, get your money back',
  description: 'Balances settle automatically. No one owes anyone.'
}];
export function HowItWorks() {
  return <section id="how-it-works" className="py-28 lg:py-36 bg-white" data-id="element-144">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-145">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-146">
          <div className="inline-flex bg-kitty-yellow-100 text-kitty-yellow-800 rounded-full px-3 py-1 text-xs font-semibold mb-4" data-id="element-147">
            How it works
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-kitty-dark mb-4 tracking-tight" data-id="element-148">
            Simple as 1, 2, 3, done.
          </h2>
          <p className="text-lg text-gray-500 max-w-xl mx-auto mb-3" data-id="element-149">
            Everyone adds money upfront. KittyPot balances everything
            automatically.
          </p>
          <p className="text-sm font-semibold text-kitty-dark/50 mb-5" data-id="element-150">
            No chasing. No spreadsheets. No stress.
          </p>
          <div className="inline-flex items-center gap-1.5 text-sm text-gray-400 font-medium" data-id="element-151">
            <ClockIcon className="w-4 h-4" data-id="element-152" />
            Set up in under 30 seconds
          </div>
        </div>

        <div className="relative" data-id="element-153">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0 border-t-2 border-dashed border-kitty-yellow-200 -z-10" data-id="element-154"></div>

          <div className="grid md:grid-cols-4 gap-8 md:gap-4" data-id="element-155">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="relative flex flex-col items-center text-center group" data-id="element-156">
                <div className="w-24 h-24 rounded-3xl bg-kitty-yellow-50 flex items-center justify-center mb-6 group-hover:bg-kitty-yellow-100 transition-colors relative shadow-sm border border-kitty-yellow-100" data-id="element-157">
                  {/* Number badge */}
                  <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-kitty-yellow text-kitty-dark font-bold flex items-center justify-center border-4 border-white shadow-sm" data-id="element-158">
                    {index + 1}
                  </div>
                  {step.icon}
                </div>
                <h3 className="text-xl font-bold text-kitty-dark mb-2" data-id="element-159">
                  {step.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed px-2" data-id="element-160">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}